module.exports = __webpack_public_path__ + "img/crescita-sostenibile-01.e0fa2f93.svg";